/**
 * Plain sentences about what a change would do (TRO-432) and whether it
 * would get a labelled verdict wrong (TRO-434). Shared by the editor's Save
 * and the proposals review, so both say it the same way.
 */

/** One sentence about a blast-radius answer, or '' when there is nothing to say. */
export function blastRadiusSentence(br) {
  if (!br) return '';
  if (br.refused) return br.message || '';
  if (br.note === 'no_change') return '';
  if (!br.total) return `No verdicts in the last ${br.window_days || 30} days to compare against.`;
  const scope = br.sampled ? `a sample of ${br.total} of ${br.population}` : `${br.total}`;
  const flips = br.changed
    ? `${br.changed} would change (${br.flips_pass_to_fail} pass to fail, ${br.flips_fail_to_pass} fail to pass)`
    : 'none would change';
  const unknown = br.unknown ? ` ${br.unknown} could not be recomputed without re-running a judge.` : '';
  return `Of ${scope} verdicts in the last ${br.window_days || 30} days, ${flips}.${unknown}`;
}

/** { tone: 'danger' | 'muted' | 'ok', text } for a regression-gate result, or null. */
export function regressionSentence(reg) {
  if (!reg) return null;
  if (reg.gate === 'not_replayable') {
    return { tone: 'muted', text: 'Not checked against the verdicts people labelled: this changes a step that calls a model, and replaying it would re-run that model.' };
  }
  const plural = (n) => (n === 1 ? '' : 's');
  if (reg.flipped > 0) {
    return { tone: 'danger', text: `This would get ${reg.flipped} verdict${plural(reg.flipped)} people labelled wrong.` };
  }
  if (!reg.checked) {
    return { tone: 'muted', text: 'No labelled verdicts could be checked against this change yet.' };
  }
  const fixed = reg.fixed ? ` ${reg.fixed} would become right.` : '';
  return { tone: 'ok', text: `Checked against ${reg.checked} verdict${plural(reg.checked)} people labelled: none would become wrong.${fixed}` };
}
